module.exports = __webpack_public_path__ + "img/DE02768.fa69ff39.png";